// extracted by mini-css-extract-plugin
module.exports = {"starRating":"StarRating-module_starRating_3N74E","stars":"StarRating-module_stars_1wavU"};